// Multilingual content for Casa di Cataleya
// 9 languages: en, sq, el, it, de, nl, zh, pl, cs

export const LANGUAGES = [
  { code: "en", label: "English",   short: "EN" },
  { code: "sq", label: "Shqip",     short: "SQ" },
  { code: "el", label: "Ελληνικά",  short: "EL" },
  { code: "it", label: "Italiano",  short: "IT" },
  { code: "de", label: "Deutsch",   short: "DE" },
  { code: "nl", label: "Nederlands",short: "NL" },
  { code: "zh", label: "中文",       short: "ZH" },
  { code: "pl", label: "Polski",    short: "PL" },
  { code: "cs", label: "Čeština",   short: "CS" },
];

export const t = {
  en: {
    nav: { stay: "The Villa", spaces: "Spaces", gallery: "Gallery", amenities: "Amenities", location: "Location", book: "Reserve" },
    hero: {
      overline: "Zakynthos · Ionian Sea",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "A Mediterranean retreat with twin sea-view residences, where slow mornings meet endless Ionian horizons.",
      cta: "Reserve via WhatsApp",
      secondary: "Discover the villa",
    },
    intro: {
      overline: "A boutique sea-view villa",
      title: "Two identical homes. One unforgettable view.",
      body: "Casa di Cataleya is a private Greek villa composed of two mirrored floors — each a complete home with two bedrooms, a sun-filled living room, a marble bathroom and a private terrace gazing over the Zakynthos coastline. Book one floor, or both, for a family-sized escape.",
    },
    spaces: {
      overline: "The Residences",
      title: "Twin floors, mirrored to perfection",
      floor1: { tag: "Ground Floor", title: "The Garden Residence", desc: "Direct access to the garden and parking. Two bedrooms, open-plan living, full bathroom and a shaded outdoor terrace." },
      floor2: { tag: "Upper Floor", title: "The Sea-View Residence", desc: "Two bedrooms, a bright lounge and a private terrace with sweeping panoramas of the Zakynthos sea." },
      features: ["2 bedrooms", "1 living room", "1 marble bathroom", "Sea-view terrace"],
    },
    amenities: {
      overline: "Everything you need",
      title: "Thoughtfully appointed",
      list: [
        { t: "High-speed Wi-Fi",       d: "Stream, work, or video-call seamlessly." },
        { t: "Air conditioning",       d: "Climate control in every room." },
        { t: "Marble bathroom",        d: "Rainfall shower, premium finishes." },
        { t: "Private parking",        d: "On-site parking for guests." },
        { t: "Sea-view terrace",       d: "Sunrise and sunset over the Ionian." },
        { t: "Fully equipped kitchen", d: "Cook with the freshest local produce." },
        { t: "Linens & towels",        d: "Crisp cotton, prepared for arrival." },
        { t: "Self check-in",          d: "Arrive on your schedule." },
      ],
    },
    gallery: { overline: "Gallery", title: "Light, stone, and sea" },
    location: {
      overline: "The Setting",
      title: "Zakynthos, Ionian Islands",
      body: "Set on the legendary island of Zakynthos — home to Navagio Beach, the Blue Caves and turquoise waters — Casa di Cataleya is your base for both peaceful retreat and authentic Greek discovery.",
      points: ["Minutes from sandy beaches", "Tavernas and markets nearby", "Easy access to Zante Town", "Quiet, residential setting"],
    },
    booking: {
      overline: "Reservations",
      title: "Reserve directly on WhatsApp",
      body: "Fill in your details below and we will receive your request instantly via WhatsApp. We respond within hours.",
      first: "First name",
      last: "Last name",
      country: "Country",
      arrival: "Check-in",
      departure: "Check-out",
      guests: "Guests",
      floor: "Floor preference",
      floorAny: "Either floor",
      floorGround: "Ground floor",
      floorUpper: "Upper floor",
      floorBoth: "Both floors",
      message: "Special requests (extras, transfers, etc.)",
      messagePh: "Anything we should know to prepare your stay…",
      submit: "Send via WhatsApp",
      note: "By sending, WhatsApp will open with your message ready for one tap.",
      required: "Please fill in your name, dates and country.",
      waLabel: "Or message us directly",
    },
    footer: {
      tagline: "A private villa on the island of Zakynthos.",
      rights: "All rights reserved.",
      contact: "Contact",
    },
    waMsg: {
      header: "Booking request — Casa di Cataleya",
      name: "Name",
      country: "Country",
      dates: "Dates",
      guests: "Guests",
      floor: "Floor",
      notes: "Notes",
    },
  },

  sq: {
    nav: { stay: "Villa", spaces: "Hapësirat", gallery: "Galeria", amenities: "Komoditetet", location: "Vendndodhja", book: "Rezervo" },
    hero: {
      overline: "Zakynthos · Deti Jon",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Një strehë mesdhetare me dy banesa identike me pamje nga deti, ku mëngjeset e qeta takohen me horizontin e pafund të Jonit.",
      cta: "Rezervo me WhatsApp",
      secondary: "Zbulo villën",
    },
    intro: {
      overline: "Villa butik me pamje nga deti",
      title: "Dy shtëpi identike. Një pamje e paharrueshme.",
      body: "Casa di Cataleya është një villë private greke me dy kate të pasqyruara — secili një shtëpi e plotë me dy dhoma gjumi, një sallon të mbushur me dritë, një banjo mermeri dhe një tarracë private me pamje nga bregdeti i Zakynthos. Rezervo një kat, ose të dy, për një pushim familjar.",
    },
    spaces: {
      overline: "Banesat",
      title: "Dy kate, të pasqyruara në mënyrë të përsosur",
      floor1: { tag: "Kati i parë", title: "Banesa e Kopshtit", desc: "Akses i drejtpërdrejtë në kopsht dhe parkim. Dy dhoma gjumi, sallon i hapur, banjo e plotë dhe tarracë e jashtme me hije." },
      floor2: { tag: "Kati i dytë", title: "Banesa me Pamje nga Deti", desc: "Dy dhoma gjumi, një sallon i ndritshëm dhe një tarracë private me pamje panoramike nga deti i Zakynthos." },
      features: ["2 dhoma gjumi", "1 sallon", "1 banjo mermeri", "Tarracë me pamje nga deti"],
    },
    amenities: {
      overline: "Gjithçka që ju nevojitet",
      title: "Të menduara me kujdes",
      list: [
        { t: "Wi-Fi me shpejtësi të lartë", d: "Stream, punë ose video-thirrje pa probleme." },
        { t: "Ajër i kondicionuar",         d: "Kontroll i klimës në çdo dhomë." },
        { t: "Banjo mermeri",               d: "Dush me shi, mbarime premium." },
        { t: "Parkim privat",               d: "Parkim brenda pronës për mysafirët." },
        { t: "Tarracë me pamje nga deti",   d: "Lindje dhe perëndim dielli mbi Jonin." },
        { t: "Kuzhinë e pajisur plotësisht",d: "Gatuani me prodhimet lokale më të freskëta." },
        { t: "Çarçafë & peshqirë",          d: "Pambuk i pastër, të gatshëm me ardhjen tuaj." },
        { t: "Check-in i vetëm",            d: "Mbërrini sipas planit tuaj." },
      ],
    },
    gallery: { overline: "Galeria", title: "Dritë, gur dhe det" },
    location: {
      overline: "Vendndodhja",
      title: "Zakynthos, Ishujt Jonë",
      body: "Vendosur në ishullin legjendar të Zakynthosit — shtëpia e plazhit Navagio, Shpellave Blu dhe ujërave të turkezta — Casa di Cataleya është baza juaj për qetësi dhe zbulim autentik grek.",
      points: ["Minuta nga plazhet me rërë", "Taverna dhe tregje afër", "Akses i lehtë në qytetin Zante", "Mjedis i qetë, rezidencial"],
    },
    booking: {
      overline: "Rezervime",
      title: "Rezervo direkt në WhatsApp",
      body: "Plotësoni detajet tuaja më poshtë dhe ne do të marrim kërkesën tuaj menjëherë në WhatsApp. Përgjigjemi brenda pak orësh.",
      first: "Emri",
      last: "Mbiemri",
      country: "Shteti",
      arrival: "Data e ardhjes",
      departure: "Data e largimit",
      guests: "Mysafirë",
      floor: "Preferenca e katit",
      floorAny: "Cilido kat",
      floorGround: "Kati i parë",
      floorUpper: "Kati i dytë",
      floorBoth: "Të dy katet",
      message: "Kërkesa të veçanta (ekstra, transferta, etj.)",
      messagePh: "Çdo gjë që duhet të dimë për të përgatitur qëndrimin tuaj…",
      submit: "Dërgo me WhatsApp",
      note: "Duke dërguar, WhatsApp do të hapet me mesazhin tuaj të gati.",
      required: "Ju lutem plotësoni emrin, datat dhe shtetin.",
      waLabel: "Ose na shkruani direkt",
    },
    footer: {
      tagline: "Një villë private në ishullin e Zakynthos.",
      rights: "Të gjitha të drejtat e rezervuara.",
      contact: "Kontakt",
    },
    waMsg: {
      header: "Kërkesë rezervimi — Casa di Cataleya",
      name: "Emri",
      country: "Shteti",
      dates: "Datat",
      guests: "Mysafirë",
      floor: "Kati",
      notes: "Shënime",
    },
  },

  el: {
    nav: { stay: "Η Βίλα", spaces: "Χώροι", gallery: "Γκαλερί", amenities: "Παροχές", location: "Τοποθεσία", book: "Κράτηση" },
    hero: {
      overline: "Ζάκυνθος · Ιόνιο Πέλαγος",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Μια μεσογειακή απόδραση με δύο πανομοιότυπες κατοικίες με θέα στη θάλασσα, όπου τα ήρεμα πρωινά συναντούν τον ατελείωτο ορίζοντα του Ιονίου.",
      cta: "Κράτηση μέσω WhatsApp",
      secondary: "Ανακαλύψτε τη βίλα",
    },
    intro: {
      overline: "Μπουτίκ βίλα με θέα στη θάλασσα",
      title: "Δύο πανομοιότυπα σπίτια. Μια αξέχαστη θέα.",
      body: "Η Casa di Cataleya είναι μια ιδιωτική ελληνική βίλα δύο επιπέδων — κάθε όροφος ένα πλήρες σπίτι με δύο υπνοδωμάτια, ηλιόλουστο σαλόνι, μπάνιο από μάρμαρο και ιδιωτική βεράντα με θέα στις ακτές της Ζακύνθου. Κλείστε έναν όροφο ή και τους δύο.",
    },
    spaces: {
      overline: "Οι Κατοικίες",
      title: "Δύο όροφοι, τέλεια εναρμονισμένοι",
      floor1: { tag: "Ισόγειο", title: "Κατοικία Κήπου", desc: "Άμεση πρόσβαση στον κήπο και το πάρκινγκ. Δύο υπνοδωμάτια, ενιαίος χώρος, πλήρες μπάνιο και σκιερή βεράντα." },
      floor2: { tag: "Πρώτος Όροφος", title: "Κατοικία με Θέα Θάλασσας", desc: "Δύο υπνοδωμάτια, φωτεινό σαλόνι και ιδιωτική βεράντα με πανοραμική θέα στη θάλασσα της Ζακύνθου." },
      features: ["2 υπνοδωμάτια", "1 σαλόνι", "1 μαρμάρινο μπάνιο", "Βεράντα με θέα στη θάλασσα"],
    },
    amenities: {
      overline: "Όλα όσα χρειάζεστε",
      title: "Με προσοχή στη λεπτομέρεια",
      list: [
        { t: "Wi-Fi υψηλής ταχύτητας", d: "Streaming, εργασία ή βιντεοκλήσεις χωρίς προβλήματα." },
        { t: "Κλιματισμός",             d: "Έλεγχος θερμοκρασίας σε κάθε δωμάτιο." },
        { t: "Μαρμάρινο μπάνιο",        d: "Ντους τύπου βροχή, πολυτελή φινιρίσματα." },
        { t: "Ιδιωτικό πάρκινγκ",       d: "Πάρκινγκ εντός για τους επισκέπτες." },
        { t: "Βεράντα με θέα",          d: "Ανατολή και δύση πάνω από το Ιόνιο." },
        { t: "Πλήρως εξοπλισμένη κουζίνα", d: "Μαγειρέψτε με ντόπια φρέσκα προϊόντα." },
        { t: "Σεντόνια & πετσέτες",     d: "Φρέσκο βαμβάκι, έτοιμα στην άφιξη." },
        { t: "Self check-in",           d: "Φτάστε με το δικό σας πρόγραμμα." },
      ],
    },
    gallery: { overline: "Γκαλερί", title: "Φως, πέτρα και θάλασσα" },
    location: {
      overline: "Η Τοποθεσία",
      title: "Ζάκυνθος, Ιόνια Νησιά",
      body: "Στο θρυλικό νησί της Ζακύνθου — με την παραλία του Ναυαγίου, τις Γαλάζιες Σπηλιές και τα τιρκουάζ νερά — η Casa di Cataleya είναι η βάση σας για ηρεμία και αυθεντική ελληνική εξερεύνηση.",
      points: ["Λίγα λεπτά από αμμώδεις παραλίες", "Ταβέρνες και αγορές κοντά", "Εύκολη πρόσβαση στη Χώρα", "Ήσυχη κατοικημένη περιοχή"],
    },
    booking: {
      overline: "Κρατήσεις",
      title: "Κάντε κράτηση απευθείας στο WhatsApp",
      body: "Συμπληρώστε τα στοιχεία σας και θα λάβουμε το αίτημά σας άμεσα στο WhatsApp. Απαντάμε εντός ωρών.",
      first: "Όνομα",
      last: "Επώνυμο",
      country: "Χώρα",
      arrival: "Άφιξη",
      departure: "Αναχώρηση",
      guests: "Επισκέπτες",
      floor: "Προτίμηση ορόφου",
      floorAny: "Οποιοσδήποτε όροφος",
      floorGround: "Ισόγειο",
      floorUpper: "Πρώτος όροφος",
      floorBoth: "Και οι δύο όροφοι",
      message: "Ειδικά αιτήματα (έξτρα, μεταφορές κ.λπ.)",
      messagePh: "Οτιδήποτε πρέπει να γνωρίζουμε για την προετοιμασία της διαμονής σας…",
      submit: "Αποστολή μέσω WhatsApp",
      note: "Με την αποστολή θα ανοίξει το WhatsApp με το μήνυμά σας έτοιμο.",
      required: "Συμπληρώστε όνομα, ημερομηνίες και χώρα.",
      waLabel: "Ή στείλτε μας απευθείας",
    },
    footer: {
      tagline: "Μια ιδιωτική βίλα στο νησί της Ζακύνθου.",
      rights: "Με επιφύλαξη παντός δικαιώματος.",
      contact: "Επικοινωνία",
    },
    waMsg: {
      header: "Αίτημα κράτησης — Casa di Cataleya",
      name: "Όνομα",
      country: "Χώρα",
      dates: "Ημερομηνίες",
      guests: "Επισκέπτες",
      floor: "Όροφος",
      notes: "Σημειώσεις",
    },
  },

  it: {
    nav: { stay: "La Villa", spaces: "Spazi", gallery: "Galleria", amenities: "Servizi", location: "Posizione", book: "Prenota" },
    hero: {
      overline: "Zacinto · Mar Ionio",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Un rifugio mediterraneo con due residenze gemelle vista mare, dove le mattine lente incontrano l'orizzonte infinito dello Ionio.",
      cta: "Prenota su WhatsApp",
      secondary: "Scopri la villa",
    },
    intro: {
      overline: "Villa boutique vista mare",
      title: "Due case identiche. Una vista indimenticabile.",
      body: "Casa di Cataleya è una villa greca privata composta da due piani speculari — ciascuno una casa completa con due camere, salotto luminoso, bagno in marmo e terrazza privata affacciata sulla costa di Zacinto. Prenota un piano o entrambi.",
    },
    spaces: {
      overline: "Le Residenze",
      title: "Due piani, perfettamente speculari",
      floor1: { tag: "Piano Terra", title: "Residenza del Giardino", desc: "Accesso diretto al giardino e al parcheggio. Due camere, zona giorno, bagno e terrazza esterna ombreggiata." },
      floor2: { tag: "Primo Piano", title: "Residenza Vista Mare", desc: "Due camere, salotto luminoso e terrazza privata con panorama sulla costa di Zacinto." },
      features: ["2 camere da letto", "1 salotto", "1 bagno in marmo", "Terrazza vista mare"],
    },
    amenities: {
      overline: "Tutto ciò che serve",
      title: "Pensato nei dettagli",
      list: [
        { t: "Wi-Fi ad alta velocità", d: "Streaming, lavoro o videochiamate senza interruzioni." },
        { t: "Aria condizionata",       d: "Climatizzazione in ogni stanza." },
        { t: "Bagno in marmo",          d: "Doccia a pioggia, finiture premium." },
        { t: "Parcheggio privato",      d: "Posti auto in struttura." },
        { t: "Terrazza vista mare",     d: "Alba e tramonto sullo Ionio." },
        { t: "Cucina attrezzata",       d: "Cucina con i prodotti locali freschi." },
        { t: "Lenzuola & asciugamani",  d: "Cotone fresco, pronti all'arrivo." },
        { t: "Check-in autonomo",       d: "Arriva quando preferisci." },
      ],
    },
    gallery: { overline: "Galleria", title: "Luce, pietra e mare" },
    location: {
      overline: "Il Luogo",
      title: "Zacinto, Isole Ionie",
      body: "Sull'isola leggendaria di Zacinto — patria della spiaggia del Naufragio, delle Grotte Azzurre e di acque turchesi — Casa di Cataleya è la base perfetta per relax e scoperta autentica.",
      points: ["A pochi minuti dalle spiagge", "Taverne e mercati nelle vicinanze", "Facile accesso a Zante", "Ambiente residenziale tranquillo"],
    },
    booking: {
      overline: "Prenotazioni",
      title: "Prenota direttamente su WhatsApp",
      body: "Compila i tuoi dati e riceveremo subito la tua richiesta su WhatsApp. Rispondiamo entro poche ore.",
      first: "Nome",
      last: "Cognome",
      country: "Paese",
      arrival: "Check-in",
      departure: "Check-out",
      guests: "Ospiti",
      floor: "Preferenza piano",
      floorAny: "Qualsiasi piano",
      floorGround: "Piano terra",
      floorUpper: "Primo piano",
      floorBoth: "Entrambi i piani",
      message: "Richieste speciali (extra, transfer, ecc.)",
      messagePh: "Tutto ciò che dovremmo sapere per preparare il tuo soggiorno…",
      submit: "Invia su WhatsApp",
      note: "Inviando, WhatsApp si aprirà con il tuo messaggio pronto.",
      required: "Inserisci nome, date e paese.",
      waLabel: "Oppure scrivici direttamente",
    },
    footer: {
      tagline: "Villa privata sull'isola di Zacinto.",
      rights: "Tutti i diritti riservati.",
      contact: "Contatti",
    },
    waMsg: {
      header: "Richiesta prenotazione — Casa di Cataleya",
      name: "Nome",
      country: "Paese",
      dates: "Date",
      guests: "Ospiti",
      floor: "Piano",
      notes: "Note",
    },
  },

  de: {
    nav: { stay: "Die Villa", spaces: "Räume", gallery: "Galerie", amenities: "Ausstattung", location: "Lage", book: "Reservieren" },
    hero: {
      overline: "Zakynthos · Ionisches Meer",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Ein mediterraner Rückzugsort mit zwei identischen Residenzen am Meer, wo ruhige Morgen den endlosen Horizont des Ionischen Meeres treffen.",
      cta: "Per WhatsApp reservieren",
      secondary: "Villa entdecken",
    },
    intro: {
      overline: "Boutique-Villa mit Meerblick",
      title: "Zwei identische Wohnungen. Ein unvergesslicher Ausblick.",
      body: "Casa di Cataleya ist eine private griechische Villa mit zwei spiegelgleichen Etagen — jede ein komplettes Zuhause mit zwei Schlafzimmern, einem sonnendurchfluteten Wohnzimmer, einem Marmorbad und einer privaten Terrasse mit Blick auf die Küste von Zakynthos.",
    },
    spaces: {
      overline: "Die Residenzen",
      title: "Zwei Etagen, perfekt gespiegelt",
      floor1: { tag: "Erdgeschoss", title: "Gartenresidenz", desc: "Direkter Zugang zum Garten und Parkplatz. Zwei Schlafzimmer, offener Wohnbereich, Bad und schattige Außenterrasse." },
      floor2: { tag: "Obergeschoss", title: "Meerblick-Residenz", desc: "Zwei Schlafzimmer, helles Wohnzimmer und private Terrasse mit weitem Blick auf das Meer von Zakynthos." },
      features: ["2 Schlafzimmer", "1 Wohnzimmer", "1 Marmorbad", "Terrasse mit Meerblick"],
    },
    amenities: {
      overline: "Alles was Sie brauchen",
      title: "Mit Sorgfalt eingerichtet",
      list: [
        { t: "Schnelles WLAN",        d: "Streamen, arbeiten oder Videoanrufe nahtlos." },
        { t: "Klimaanlage",            d: "Klimaregelung in jedem Zimmer." },
        { t: "Marmorbad",              d: "Regendusche, hochwertige Ausstattung." },
        { t: "Privater Parkplatz",     d: "Parkplätze auf dem Grundstück." },
        { t: "Terrasse mit Meerblick", d: "Sonnenaufgang und -untergang über dem Ionischen Meer." },
        { t: "Voll ausgestattete Küche", d: "Mit frischen lokalen Produkten kochen." },
        { t: "Bettwäsche & Handtücher", d: "Frische Baumwolle, bereit zur Anreise." },
        { t: "Self Check-in",          d: "Kommen Sie nach Ihrem Zeitplan an." },
      ],
    },
    gallery: { overline: "Galerie", title: "Licht, Stein und Meer" },
    location: {
      overline: "Die Lage",
      title: "Zakynthos, Ionische Inseln",
      body: "Auf der legendären Insel Zakynthos — Heimat des Schiffswrack-Strands, der Blauen Grotten und türkisfarbenen Gewässer — ist Casa di Cataleya Ihre Basis für Ruhe und authentische griechische Entdeckungen.",
      points: ["Minuten von Sandstränden", "Tavernen und Märkte in der Nähe", "Einfacher Zugang zur Stadt", "Ruhige Wohnlage"],
    },
    booking: {
      overline: "Reservierungen",
      title: "Direkt über WhatsApp reservieren",
      body: "Geben Sie Ihre Daten ein und wir erhalten Ihre Anfrage sofort per WhatsApp. Wir antworten innerhalb von Stunden.",
      first: "Vorname",
      last: "Nachname",
      country: "Land",
      arrival: "Anreise",
      departure: "Abreise",
      guests: "Gäste",
      floor: "Etagenwunsch",
      floorAny: "Beliebige Etage",
      floorGround: "Erdgeschoss",
      floorUpper: "Obergeschoss",
      floorBoth: "Beide Etagen",
      message: "Sonderwünsche (Extras, Transfer, etc.)",
      messagePh: "Alles, was wir für Ihren Aufenthalt wissen sollten…",
      submit: "Über WhatsApp senden",
      note: "Beim Senden öffnet sich WhatsApp mit Ihrer fertigen Nachricht.",
      required: "Bitte Name, Daten und Land angeben.",
      waLabel: "Oder schreiben Sie uns direkt",
    },
    footer: {
      tagline: "Eine private Villa auf der Insel Zakynthos.",
      rights: "Alle Rechte vorbehalten.",
      contact: "Kontakt",
    },
    waMsg: {
      header: "Buchungsanfrage — Casa di Cataleya",
      name: "Name",
      country: "Land",
      dates: "Daten",
      guests: "Gäste",
      floor: "Etage",
      notes: "Notizen",
    },
  },

  nl: {
    nav: { stay: "De Villa", spaces: "Ruimtes", gallery: "Galerij", amenities: "Voorzieningen", location: "Locatie", book: "Reserveren" },
    hero: {
      overline: "Zakynthos · Ionische Zee",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Een mediterrane retraite met twee identieke residenties met zeezicht, waar rustige ochtenden samenkomen met de eindeloze horizon van de Ionische Zee.",
      cta: "Reserveren via WhatsApp",
      secondary: "Ontdek de villa",
    },
    intro: {
      overline: "Boutique villa met zeezicht",
      title: "Twee identieke woningen. Eén onvergetelijk uitzicht.",
      body: "Casa di Cataleya is een privé Griekse villa met twee spiegelende verdiepingen — elk een complete woning met twee slaapkamers, een zonnige woonkamer, een marmeren badkamer en een privéterras met uitzicht op de kust van Zakynthos.",
    },
    spaces: {
      overline: "De Residenties",
      title: "Twee verdiepingen, perfect gespiegeld",
      floor1: { tag: "Begane grond", title: "Tuinresidentie", desc: "Directe toegang tot tuin en parkeerplaats. Twee slaapkamers, open leefruimte, badkamer en beschaduwd terras." },
      floor2: { tag: "Eerste verdieping", title: "Zeezicht Residentie", desc: "Twee slaapkamers, een lichte lounge en een privéterras met panoramisch uitzicht op de zee van Zakynthos." },
      features: ["2 slaapkamers", "1 woonkamer", "1 marmeren badkamer", "Zeezicht terras"],
    },
    amenities: {
      overline: "Alles wat u nodig heeft",
      title: "Met zorg ingericht",
      list: [
        { t: "Snelle Wi-Fi",          d: "Streamen, werken of videobellen zonder problemen." },
        { t: "Airconditioning",       d: "Klimaatregeling in elke kamer." },
        { t: "Marmeren badkamer",     d: "Regendouche, premium afwerking." },
        { t: "Privé parkeren",        d: "Parkeren op het terrein." },
        { t: "Terras met zeezicht",   d: "Zonsopgang en zonsondergang boven de Ionische Zee." },
        { t: "Volledig uitgeruste keuken", d: "Kook met verse lokale producten." },
        { t: "Lakens & handdoeken",   d: "Fris katoen, klaar bij aankomst." },
        { t: "Self check-in",         d: "Aankomen op uw eigen tijd." },
      ],
    },
    gallery: { overline: "Galerij", title: "Licht, steen en zee" },
    location: {
      overline: "De Locatie",
      title: "Zakynthos, Ionische Eilanden",
      body: "Op het legendarische eiland Zakynthos — thuis van Navagio Beach, de Blauwe Grotten en turquoise wateren — is Casa di Cataleya uw uitvalsbasis voor rust en authentieke Griekse ontdekking.",
      points: ["Minuten van zandstranden", "Taverna's en markten dichtbij", "Eenvoudige toegang tot Zante", "Rustige residentiële omgeving"],
    },
    booking: {
      overline: "Reserveringen",
      title: "Reserveer direct via WhatsApp",
      body: "Vul uw gegevens in en wij ontvangen uw aanvraag direct via WhatsApp. Wij reageren binnen enkele uren.",
      first: "Voornaam",
      last: "Achternaam",
      country: "Land",
      arrival: "Aankomst",
      departure: "Vertrek",
      guests: "Gasten",
      floor: "Voorkeur verdieping",
      floorAny: "Geen voorkeur",
      floorGround: "Begane grond",
      floorUpper: "Eerste verdieping",
      floorBoth: "Beide verdiepingen",
      message: "Bijzondere wensen (extra's, transfers, enz.)",
      messagePh: "Alles wat wij moeten weten voor uw verblijf…",
      submit: "Verzenden via WhatsApp",
      note: "Bij verzenden opent WhatsApp met uw bericht klaar.",
      required: "Vul naam, data en land in.",
      waLabel: "Of stuur ons direct een bericht",
    },
    footer: {
      tagline: "Een privé villa op het eiland Zakynthos.",
      rights: "Alle rechten voorbehouden.",
      contact: "Contact",
    },
    waMsg: {
      header: "Reserveringsaanvraag — Casa di Cataleya",
      name: "Naam",
      country: "Land",
      dates: "Data",
      guests: "Gasten",
      floor: "Verdieping",
      notes: "Notities",
    },
  },

  zh: {
    nav: { stay: "别墅", spaces: "空间", gallery: "画廊", amenities: "设施", location: "位置", book: "预订" },
    hero: {
      overline: "扎金索斯 · 爱奥尼亚海",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "一处地中海静修之所，双子海景住所相映成趣，宁静的清晨遇见无垠的爱奥尼亚海平线。",
      cta: "通过 WhatsApp 预订",
      secondary: "探索别墅",
    },
    intro: {
      overline: "精品海景别墅",
      title: "两间相同的居所，一片难忘的海景。",
      body: "Casa di Cataleya 是一栋位于希腊的私人别墅，由两层镜像布局组成 —— 每层均为完整居所，包含两间卧室、阳光客厅、大理石浴室及俯瞰扎金索斯海岸的私人露台。可预订单层或整栋。",
    },
    spaces: {
      overline: "居所",
      title: "两层楼，完美对称",
      floor1: { tag: "一层", title: "花园居所", desc: "直接通往花园与停车区。两间卧室、开放式起居室、完整浴室与遮阴露台。" },
      floor2: { tag: "二层", title: "海景居所", desc: "两间卧室、明亮的休息室，以及俯瞰扎金索斯海景的私人露台。" },
      features: ["2 间卧室", "1 间客厅", "1 间大理石浴室", "海景露台"],
    },
    amenities: {
      overline: "所需的一切",
      title: "悉心配置",
      list: [
        { t: "高速 Wi-Fi", d: "畅享流媒体、办公与视频通话。" },
        { t: "空调",       d: "每个房间均可调节温度。" },
        { t: "大理石浴室", d: "雨淋花洒，高端配置。" },
        { t: "私人停车",   d: "园内提供停车位。" },
        { t: "海景露台",   d: "日出日落尽收眼底。" },
        { t: "全套厨房",   d: "用当地新鲜食材烹饪。" },
        { t: "床品与毛巾", d: "全新棉质，到达即可使用。" },
        { t: "自助入住",   d: "按您的时间到达。" },
      ],
    },
    gallery: { overline: "画廊", title: "光、石与海" },
    location: {
      overline: "所在地",
      title: "扎金索斯，爱奥尼亚群岛",
      body: "Casa di Cataleya 位于传奇的扎金索斯岛 —— 沉船湾、蓝洞与碧蓝海水的故乡 —— 是您悠然度假与希腊探索的理想之所。",
      points: ["距沙滩仅几分钟", "附近有餐厅和市场", "轻松前往赞特镇", "宁静住宅区"],
    },
    booking: {
      overline: "预订",
      title: "通过 WhatsApp 直接预订",
      body: "请填写以下信息，我们将通过 WhatsApp 即时收到您的请求。我们会在数小时内回复。",
      first: "名",
      last: "姓",
      country: "国家",
      arrival: "入住日期",
      departure: "退房日期",
      guests: "人数",
      floor: "楼层偏好",
      floorAny: "任意楼层",
      floorGround: "一层",
      floorUpper: "二层",
      floorBoth: "两层",
      message: "特殊要求（额外服务、接送等）",
      messagePh: "我们准备您住宿时需知道的任何信息…",
      submit: "通过 WhatsApp 发送",
      note: "发送时，WhatsApp 将打开并准备好您的消息。",
      required: "请填写姓名、日期和国家。",
      waLabel: "或直接给我们发消息",
    },
    footer: {
      tagline: "扎金索斯岛上的私人别墅。",
      rights: "保留所有权利。",
      contact: "联系",
    },
    waMsg: {
      header: "预订请求 — Casa di Cataleya",
      name: "姓名",
      country: "国家",
      dates: "日期",
      guests: "人数",
      floor: "楼层",
      notes: "备注",
    },
  },

  pl: {
    nav: { stay: "Willa", spaces: "Przestrzenie", gallery: "Galeria", amenities: "Udogodnienia", location: "Lokalizacja", book: "Rezerwuj" },
    hero: {
      overline: "Zakynthos · Morze Jońskie",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Śródziemnomorska oaza z dwoma identycznymi rezydencjami z widokiem na morze, gdzie spokojne poranki spotykają nieskończony horyzont Morza Jońskiego.",
      cta: "Rezerwuj przez WhatsApp",
      secondary: "Odkryj willę",
    },
    intro: {
      overline: "Butikowa willa z widokiem na morze",
      title: "Dwa identyczne domy. Jeden niezapomniany widok.",
      body: "Casa di Cataleya to prywatna grecka willa składająca się z dwóch lustrzanych pięter — każde jest kompletnym domem z dwiema sypialniami, słonecznym salonem, marmurową łazienką i prywatnym tarasem z widokiem na wybrzeże Zakynthos.",
    },
    spaces: {
      overline: "Rezydencje",
      title: "Dwa piętra, doskonale lustrzane",
      floor1: { tag: "Parter", title: "Rezydencja Ogrodowa", desc: "Bezpośredni dostęp do ogrodu i parkingu. Dwie sypialnie, otwarta przestrzeń dzienna, łazienka i zacieniony taras." },
      floor2: { tag: "Piętro", title: "Rezydencja z Widokiem na Morze", desc: "Dwie sypialnie, jasny salon i prywatny taras z panoramicznym widokiem na morze Zakynthos." },
      features: ["2 sypialnie", "1 salon", "1 marmurowa łazienka", "Taras z widokiem na morze"],
    },
    amenities: {
      overline: "Wszystko, czego potrzebujesz",
      title: "Starannie urządzona",
      list: [
        { t: "Szybkie Wi-Fi",       d: "Streaming, praca lub wideorozmowy bez przeszkód." },
        { t: "Klimatyzacja",         d: "Klimatyzacja w każdym pomieszczeniu." },
        { t: "Marmurowa łazienka",   d: "Prysznic deszczowy, wysokiej jakości wykończenia." },
        { t: "Prywatny parking",     d: "Parking na terenie." },
        { t: "Taras z widokiem",     d: "Wschód i zachód słońca nad Morzem Jońskim." },
        { t: "W pełni wyposażona kuchnia", d: "Gotuj ze świeżymi lokalnymi produktami." },
        { t: "Pościel i ręczniki",   d: "Świeża bawełna, gotowa na przyjazd." },
        { t: "Samodzielne zameldowanie", d: "Przyjedź w swoim czasie." },
      ],
    },
    gallery: { overline: "Galeria", title: "Światło, kamień i morze" },
    location: {
      overline: "Miejsce",
      title: "Zakynthos, Wyspy Jońskie",
      body: "Na legendarnej wyspie Zakynthos — domu plaży Navagio, Niebieskich Grot i turkusowych wód — Casa di Cataleya jest Twoją bazą do spokojnego wypoczynku i autentycznego greckiego odkrywania.",
      points: ["Minuty od piaszczystych plaż", "Tawerny i targi w pobliżu", "Łatwy dostęp do miasta Zante", "Cicha, mieszkalna okolica"],
    },
    booking: {
      overline: "Rezerwacje",
      title: "Zarezerwuj bezpośrednio na WhatsApp",
      body: "Wypełnij dane, a otrzymamy Twoją prośbę natychmiast na WhatsApp. Odpowiadamy w ciągu kilku godzin.",
      first: "Imię",
      last: "Nazwisko",
      country: "Kraj",
      arrival: "Zameldowanie",
      departure: "Wymeldowanie",
      guests: "Goście",
      floor: "Preferowane piętro",
      floorAny: "Dowolne piętro",
      floorGround: "Parter",
      floorUpper: "Piętro",
      floorBoth: "Oba piętra",
      message: "Specjalne życzenia (dodatki, transfery itd.)",
      messagePh: "Wszystko, co powinniśmy wiedzieć, aby przygotować Twój pobyt…",
      submit: "Wyślij przez WhatsApp",
      note: "Po wysłaniu otworzy się WhatsApp z gotową wiadomością.",
      required: "Wypełnij imię, daty i kraj.",
      waLabel: "Lub napisz do nas bezpośrednio",
    },
    footer: {
      tagline: "Prywatna willa na wyspie Zakynthos.",
      rights: "Wszelkie prawa zastrzeżone.",
      contact: "Kontakt",
    },
    waMsg: {
      header: "Prośba o rezerwację — Casa di Cataleya",
      name: "Imię i nazwisko",
      country: "Kraj",
      dates: "Daty",
      guests: "Goście",
      floor: "Piętro",
      notes: "Uwagi",
    },
  },

  cs: {
    nav: { stay: "Vila", spaces: "Prostory", gallery: "Galerie", amenities: "Vybavení", location: "Lokalita", book: "Rezervovat" },
    hero: {
      overline: "Zakynthos · Jónské moře",
      title1: "Casa di",
      title2: "Cataleya",
      subtitle: "Středomořský útěk se dvěma totožnými rezidencemi s výhledem na moře, kde se klidná rána potkávají s nekonečným obzorem Jónského moře.",
      cta: "Rezervovat přes WhatsApp",
      secondary: "Objevte vilu",
    },
    intro: {
      overline: "Butiková vila s výhledem na moře",
      title: "Dva totožné domovy. Jeden nezapomenutelný výhled.",
      body: "Casa di Cataleya je soukromá řecká vila se dvěma zrcadlenými patry — každé je kompletním domovem se dvěma ložnicemi, slunným obývákem, mramorovou koupelnou a soukromou terasou s výhledem na pobřeží Zakynthosu.",
    },
    spaces: {
      overline: "Rezidence",
      title: "Dvě patra, dokonale zrcadlená",
      floor1: { tag: "Přízemí", title: "Zahradní rezidence", desc: "Přímý přístup do zahrady a na parkoviště. Dvě ložnice, otevřený obývací prostor, koupelna a stinná venkovní terasa." },
      floor2: { tag: "1. patro", title: "Rezidence s výhledem na moře", desc: "Dvě ložnice, světlý salonek a soukromá terasa s panoramatickým výhledem na moře Zakynthosu." },
      features: ["2 ložnice", "1 obývací pokoj", "1 mramorová koupelna", "Terasa s výhledem na moře"],
    },
    amenities: {
      overline: "Vše, co potřebujete",
      title: "Pečlivě zařízeno",
      list: [
        { t: "Rychlé Wi-Fi",      d: "Streaming, práce nebo videohovory bez problémů." },
        { t: "Klimatizace",        d: "Regulace teploty v každém pokoji." },
        { t: "Mramorová koupelna", d: "Dešťová sprcha, prémiové prvky." },
        { t: "Soukromé parkování", d: "Parkování na pozemku." },
        { t: "Terasa s výhledem",  d: "Východ i západ slunce nad Jónským mořem." },
        { t: "Plně vybavená kuchyně", d: "Vařte s čerstvými místními produkty." },
        { t: "Lůžkoviny a ručníky", d: "Čerstvá bavlna, připravená při příjezdu." },
        { t: "Samostatné odbavení", d: "Přijeďte podle svého rozvrhu." },
      ],
    },
    gallery: { overline: "Galerie", title: "Světlo, kámen a moře" },
    location: {
      overline: "Lokalita",
      title: "Zakynthos, Jónské ostrovy",
      body: "Na legendárním ostrově Zakynthos — domov pláže Navagio, Modrých jeskyní a tyrkysových vod — je Casa di Cataleya vaší základnou pro klid a autentický řecký objev.",
      points: ["Pár minut od písečných pláží", "Taverny a tržiště poblíž", "Snadný přístup do Zante", "Klidná rezidenční oblast"],
    },
    booking: {
      overline: "Rezervace",
      title: "Rezervujte přímo přes WhatsApp",
      body: "Vyplňte své údaje a obratem obdržíme váš požadavek na WhatsApp. Odpovídáme do několika hodin.",
      first: "Jméno",
      last: "Příjmení",
      country: "Země",
      arrival: "Příjezd",
      departure: "Odjezd",
      guests: "Hosté",
      floor: "Preference patra",
      floorAny: "Libovolné patro",
      floorGround: "Přízemí",
      floorUpper: "1. patro",
      floorBoth: "Obě patra",
      message: "Speciální požadavky (extra, transfery atd.)",
      messagePh: "Cokoliv, co bychom měli vědět pro přípravu vašeho pobytu…",
      submit: "Odeslat přes WhatsApp",
      note: "Po odeslání se otevře WhatsApp s vaší připravenou zprávou.",
      required: "Vyplňte prosím jméno, data a zemi.",
      waLabel: "Nebo nám napište přímo",
    },
    footer: {
      tagline: "Soukromá vila na ostrově Zakynthos.",
      rights: "Všechna práva vyhrazena.",
      contact: "Kontakt",
    },
    waMsg: {
      header: "Žádost o rezervaci — Casa di Cataleya",
      name: "Jméno",
      country: "Země",
      dates: "Data",
      guests: "Hosté",
      floor: "Patro",
      notes: "Poznámky",
    },
  },
};
